'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'compass-drafting';
var width = 512;
var height = 512;
var aliases = ["drafting-compass"];
var unicode = 'f568';
var svgPathData = 'M352 96c0 14.1-3.1 27.6-8.6 39.7l53.9 90.3c-23.9 26-54.9 45.4-89.8 55.1L256 192 188 309.5c21.5 6.8 44.3 10.5 68 10.5c82.9 0 155.3-45 194.1-112l55.4 32C455.7 326 362.6 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L91.4 476.2 0 512l0-94.2L64 310.7C41.3 290.4 21.9 266.5 6.6 240l55.4-32c9.8 17 21.9 32.6 35.7 46.4l70.9-118.7c-5.5-12.1-8.5-25.5-8.5-39.7c0-53 43-96 96-96s96 43 96 96zm20.9 297.9c33.8-13.3 64.7-32.1 91.7-55.3L512 417.8l0 94.2-91.4-35.8-47.6-82.2zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompassDrafting = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;